import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { CustomValidationService } from '@services/custom-validation.service';
import { ErrorService } from '@services/error.service';
import { DialogService } from '@services/dialog.service';
import { LegacyPasswordService } from '@services/legacy-password.service';
import { FORM_COMP_MODES } from '@services/constants.service';
import { AuthService } from '@services/auth.service';

@Component({
    selector: 'app-password-change-form',
    templateUrl: './password-change-form.component.html',
    styleUrls: ['./password-change-form.component.scss'],
    standalone: false
})
export class PasswordChangeFormComponent implements AfterViewInit {
  @Input('username') username: string = "";
  @Input('isCreating') isCreating: boolean = false;
  @Input('mode') mode: string | undefined = "";
  @Output() exitFormEvent = new EventEmitter<true>();

  public passwordForm: FormGroup;
  public loadingSave: boolean = false;
  public newPassword: string = "";

  // necessary to reference it in the html template
  public readonly FORM_COMP_MODES = FORM_COMP_MODES;

  constructor(
    private formBuilder: FormBuilder,
    private errorService: ErrorService,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private customValidator: CustomValidationService,
    private passwordService: LegacyPasswordService,
    private authService: AuthService
  ) {
    this.passwordForm = this.formBuilder.group({
      oldPassword: [''],
      newPassword: ['', {
        validators: [Validators.required]
      }],
      newPasswordVerify: ['', {
        validators: [Validators.required],
        asyncValidators: [this.customValidator.matchPassword('newPassword', 'newPasswordVerify')]
      }],
    });
  }

  ngAfterViewInit(): void {
    if (this.mode == FORM_COMP_MODES.EDIT) {
      this.passwordForm.controls['oldPassword'].setValidators([Validators.required]);
      this.passwordForm.controls['oldPassword'].setAsyncValidators([this.customValidator.oldPasswordValid('oldPassword')]);
    }

    this.authService.getPasswordRegex().then((regex: string) => {
      this.passwordForm.controls['newPassword'].addValidators([Validators.pattern(regex)]);
    })
  }

  public onSubmit(event: any) {
    this.loadingSave = true;
    if (event.submitter.name == "" && this.passwordForm.status == "VALID") {
      this.changePassword(
        this.passwordForm.controls['newPassword'].value
      ).then(() => {
        this.loadingSave = false;
        this.exitForm();

        this.dialogService.alert(null, this.translateService.instant('Template.PasswordChangeComponent.label_passwordChangeSuccess'), 'success');
      }).catch((err) => {
        this.loadingSave = false;

        this.dialogService.alert(null, this.translateService.instant('Template.PasswordChangeComponent.label_passwordChangeError'), 'danger');

        this.errorService.printError(err);
      })
    }
  }

  private changePassword(newPassword: string): Promise<void> {
    return new Promise((resolve, reject) => {
      return this.passwordService.updatePassword(newPassword, this.username).then(() => {
        return resolve();
      }).catch((err) => {
        return reject(err);
      })
    })
  }

  private exitForm() {
    this.exitFormEvent.emit(true);
  }

  public onNewPasswordInput() {
    this.newPassword = this.passwordForm.controls['newPassword'].value;
  }

}
